import { render, staticRenderFns } from "./LoadMask.vue?vue&type=template&id=6ecf2c84&"
import script from "./LoadMask.vue?vue&type=script&lang=js&"
export * from "./LoadMask.vue?vue&type=script&lang=js&"
import style0 from "./LoadMask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports